var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75.25A6.25 6.25 0 00.5 6.5v4.965a6.25 6.25 0 1012.5 0V6.5A6.248 6.248 0 006.75.25zM10.5 11.5a3.754 3.754 0 01-3.75 3.75A3.754 3.754 0 013 11.5v-5a3.754 3.754 0 013.75-3.75A3.754 3.754 0 0110.5 6.5v5z",
    fill: "#00B9EF"
  })));
}

export default SvgZero;